import { LineLayer, ArcLayer } from '@deck.gl/layers';
const create2DLayer = (edgeViews, nodeViewMap, showEdges, pickable, selectedEdges, updated) => new LineLayer({
    id: 'edge-layer',
    data: edgeViews,
    getSourcePosition: (e) => {
        const s = nodeViewMap.get(e.s);
        if (!s) {
            return [0, 0, 0];
        }
        return [s.position[0], s.position[1]];
    },
    getTargetPosition: (e) => {
        const t = nodeViewMap.get(e.t);
        if (!t) {
            return [0, 0, 0];
        }
        return [t.position[0], t.position[1]];
    },
    getColor: (e) => (selectedEdges.has(e.id) ? [255, 255, 0, 225] : e.color),
    getWidth: (e) => (selectedEdges.has(e.id) ? e.width * 1.3 : e.width),
    updateTriggers: {
        getColor: updated,
        getWidth: updated
    },
    visible: showEdges,
    pickable,
    widthScale: 0.16,
    widthMinPixels: 1,
    widthMaxPixels: 10,
    autoHighlight: true,
    highlightColor: [255, 0, 0]
});
const create3DLayer = (edgeViews, nodeViewMap, showEdges, pickable) => new ArcLayer({
    id: `edge-layer-3d`,
    data: edgeViews,
    getSourcePosition: (e) => {
        const s = nodeViewMap.get(e.s);
        if (!s) {
            return [0, 0, 0];
        }
        return [s.position[0], s.position[1]];
    },
    getTargetPosition: (e) => {
        const t = nodeViewMap.get(e.t);
        if (!t) {
            return [0, 0, 0];
        }
        return [t.position[0], t.position[1]];
    },
    getSourceColor: (e) => e.color,
    getTargetColor: (e) => e.color,
    strokeWidth: 0.1,
    visible: showEdges,
    pickable,
    widthScale: 0.1,
    autoHighlight: true,
    highlightColor: [0, 255, 0]
});
const createEdgeLayers = (edgeViews, nodeViewMap, render3d, showEdges, pickable, depth, selectedEdges, test) => {
    if (render3d) {
        const layers3D = [create3DLayer(edgeViews[0], nodeViewMap, showEdges, pickable)];
        return layers3D;
    }
    else {
        const layers = [];
        edgeViews.forEach((viewGroup) => {
            const newLayer = create2DLayer(viewGroup, nodeViewMap, showEdges, pickable, selectedEdges, test);
            layers.push(newLayer);
        });
        return layers;
    }
};
const createMultipleLayers = (edgeViews) => {
    let idx = edgeViews.length;
    const layers = [];
    while (idx--) {
        const ev = edgeViews[idx];
        const layerId = ev.layer;
        if (layerId === undefined) {
            let defLayer = layers[0];
            if (defLayer === undefined) {
                defLayer = [ev];
                layers[0] = defLayer;
            }
            else {
                defLayer.push(ev);
            }
        }
        else {
            let targetLayer = layers[layerId.toString()];
            if (targetLayer === undefined) {
                targetLayer = [ev];
                layers[layerId.toString()] = targetLayer;
            }
            else {
                targetLayer.push(ev);
            }
        }
    }
    return layers;
};
export { createEdgeLayers, createMultipleLayers };
